import React from 'react';
import Layout from '../components/Global/Layout/Layout';
import { graphql } from 'gatsby';
import HeroSection from '../components/HomePage/HeroSection/HeroSection';
import Instagram from '../components/HomePage/instagram-carousal/InstagramCarousal';
import CategoryRowOne from '../components/HomePage/CategoryRowOne/CategoryRowOne';
import CategoryDivider from '../components/HomePage/CategoryDivider/CategoryDivider';
import LatestArrivals from '../components/HomePage/LatestArrivals/LatestArrivals';
import EmailSubscriberForm from '../components/Global/emailSubscriberForm/EmailSubscriberForm';
import SEO from '../components/Global/SEO';

const IndexPage = ({ data }) => {
	const {
		metaDescription,
		metaImage: { fluid: { src } },
		heroImage: { heroImage, title },
		heroImageText,
		heroImageTextLink: { link, link_title },
		productCategory1Description: { productCategory1Description },
		productCategory1Image: { productCategory1Image, productCategory1ImageTitle },
		productCategory1Link,
		productCategory1Name,
		productCategory2Description: { productCategory2Description },
		productCategory2Image: { productCategory2Image, productCategory2ImageTitle },
		productCategory2Link,
		productCategory2Name,
		productCategory3Description: { productCategory3Description },
		productCategory3Image: { productCategory3Image, productCategory3ImageTitle },
		productCategory3Link,
		productCategory3Name,
		productCategory4Description: { productCategory4Description },
		productCategory4Image: { productCategory4Image, productCategory4ImageTitle },
		productCategory4Link,
		productCategory4Name,
		productCategory5Description: { productCategory5Description },
		productCategory5Image: { productCategory5Image, productCategory5ImageTitle },
		productCategory5Link,
		productCategory5Name,
		newsletterText: { newsletterText },
		newsletterTitle,
		linkToInstagram
	} = data.allContentfulHomePage.nodes[0];

	return (
		<Layout>
			<SEO title="Home" description={metaDescription} image={src} />

			<HeroSection
				heroImage={heroImage}
				title={title}
				heroImageText={heroImageText}
				link={link}
				link_title={link_title}
			/>

			<CategoryRowOne
				productCategory1Image={productCategory1Image}
				productCategory1ImageTitle={productCategory1ImageTitle}
				productCategory1Description={productCategory1Description}
				productCategory1Link={productCategory1Link}
				productCategory1Name={productCategory1Name}
				productCategory2Image={productCategory2Image}
				productCategory2ImageTitle={productCategory2ImageTitle}
				productCategory2Description={productCategory2Description}
				productCategory2Link={productCategory2Link}
				productCategory2Name={productCategory2Name}
			/>
			<CategoryDivider
				productCategory1Image={productCategory3Image}
				productCategory1ImageTitle={productCategory3ImageTitle}
				productCategory1Description={productCategory3Description}
				productCategory1Link={productCategory3Link}
				productCategory1Name={productCategory3Name}
			/>
			<CategoryRowOne
				productCategory1Image={productCategory4Image}
				productCategory1ImageTitle={productCategory4ImageTitle}
				productCategory1Description={productCategory4Description}
				productCategory1Link={productCategory4Link}
				productCategory1Name={productCategory4Name}
				productCategory2Image={productCategory5Image}
				productCategory2ImageTitle={productCategory5ImageTitle}
				productCategory2Description={productCategory5Description}
				productCategory2Link={productCategory5Link}
				productCategory2Name={productCategory5Name}
			/>

			<LatestArrivals products={data.allContentfulNewArrivals.nodes} title="NEW ARRIVALS" bgColor="#e8e5e5" />
			<EmailSubscriberForm newsletterTitle={newsletterTitle} newsletterText={newsletterText} />
			<Instagram linkToInstagram={linkToInstagram} />
		</Layout>
	);
};

export const query = graphql`
	query {
		allContentfulHomePage {
			nodes {
				linkToInstagram
				newsletterText {
					newsletterText
				}
				newsletterTitle
				metaDescription
				metaImage {
					fluid {
						...GatsbyContentfulFluid
					}
				}
				heroImage {
					heroImage: fluid(maxWidth: 1500) {
						...GatsbyContentfulFluid_withWebp
					}
					title
				}
				heroImageText
				heroImageTextLink {
					link
					link_title
				}
				productCategory1Description {
					productCategory1Description
				}
				productCategory1Image {
					productCategory1Image: fluid {
						...GatsbyContentfulFluid
					}
					productCategory1ImageTitle: title
				}
				productCategory1Link
				productCategory1Name
				productCategory2Description {
					productCategory2Description
				}
				productCategory2Image {
					productCategory2Image: fluid {
						...GatsbyContentfulFluid
					}
					productCategory2ImageTitle: title
				}
				productCategory2Link
				productCategory2Name
				productCategory3Description {
					productCategory3Description
				}
				productCategory3Image {
					productCategory3Image: fluid {
						...GatsbyContentfulFluid
					}
					productCategory3ImageTitle: title
				}
				productCategory3Link
				productCategory3Name
				productCategory4Description {
					productCategory4Description
				}
				productCategory4Image {
					productCategory4Image: fluid {
						...GatsbyContentfulFluid
					}
					productCategory4ImageTitle: title
				}
				productCategory4Link
				productCategory4Name
				productCategory5Description {
					productCategory5Description
				}
				productCategory5Image {
					productCategory5Image: fluid {
						...GatsbyContentfulFluid
					}
					productCategory5ImageTitle: title
				}
				productCategory5Link
				productCategory5Name
			}
		}
		allContentfulNewArrivals {
			nodes {
				link
				price
				title
				image {
					fluid {
						...GatsbyContentfulFluid
					}
				}
			}
		}
	}
`;

export default IndexPage;
